import VCFundingProgramDetail from './VCFundingProgramDetail';

export default VCFundingProgramDetail;
